package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class TeacherAttendanceInsightsResponse(
    @SerialName("teacher_id") val teacherId: String? = null,
    @SerialName("teacher_name") val teacherName: String? = null,
    @SerialName("start_date") val startDate: String? = null,
    @SerialName("end_date") val endDate: String? = null,
    @SerialName("total_students") val totalStudents: Int? = null,
    @SerialName("class_average") val classAverage: Double? = null,
    @SerialName("good_performance_count") val goodPerformanceCount: Int? = null,
    @SerialName("average_performance_count") val averagePerformanceCount: Int? = null,
    @SerialName("needs_attention_count") val needsAttentionCount: Int? = null,
    val students: List<TeacherAttendanceInsightStudent> = emptyList(),
    val page: Int? = null,
    val limit: Int? = null,
    val total: Int? = null
)

@Serializable
data class TeacherAttendanceInsightStudent(
    @SerialName("student_id") val studentId: String? = null,
    @SerialName("student_name") val studentName: String? = null,
    @SerialName("admission_number") val admissionNumber: String? = null,
    @SerialName("roll_number") val rollNumber: String? = null,
    @SerialName("class_name") val className: String? = null,
    @SerialName("section_name") val sectionName: String? = null,
    @SerialName("total_days") val totalDays: Int? = null,
    @SerialName("attendance_percentage") val attendancePercentage: Double? = null,
    @SerialName("present_days") val presentDays: Int? = null,
    @SerialName("absent_days") val absentDays: Int? = null,
    @SerialName("late_days") val lateDays: Int? = null,
    @SerialName("excused_days") val excusedDays: Int? = null,
    @SerialName("performance_band") val performanceBand: String? = null,
    @SerialName("attendance") val attendance: TeacherAttendanceInsightAttendance? = null
)

@Serializable
data class TeacherAttendanceInsightAttendance(
    @SerialName("attendance_id") val attendanceId: String? = null,
    @SerialName("status") val status: String? = null,
    @SerialName("remarks") val remarks: String? = null,
    @SerialName("attendance_date") val attendanceDate: String? = null
)

@Serializable
data class TeacherAttendanceStatisticsResponse(
    @SerialName("teacher_id") val teacherId: String? = null,
    @SerialName("teacher_name") val teacherName: String? = null,
    @SerialName("start_date") val startDate: String? = null,
    @SerialName("end_date") val endDate: String? = null,
    @SerialName("total_class_sections") val totalClassSections: Int? = null,
    @SerialName("total_students") val totalStudents: Int? = null,
    @SerialName("overall_average_attendance_percentage") val overallAverageAttendancePercentage: Double? = null,
    @SerialName("good_performance_count") val goodPerformanceCount: Int? = null,
    @SerialName("average_performance_count") val averagePerformanceCount: Int? = null,
    @SerialName("needs_attention_count") val needsAttentionCount: Int? = null,
    @SerialName("class_sections") val classSections: List<TeacherClassSectionStat> = emptyList()
)

@Serializable
data class TeacherClassSectionStat(
    @SerialName("class_section_id") val classSectionId: String? = null,
    @SerialName("class_name") val className: String? = null,
    @SerialName("section_name") val sectionName: String? = null,
    @SerialName("total_students") val totalStudents: Int? = null,
    @SerialName("average_attendance_percentage") val averageAttendancePercentage: Double? = null,
    @SerialName("good_performance_count") val goodPerformanceCount: Int? = null,
    @SerialName("average_performance_count") val averagePerformanceCount: Int? = null,
    @SerialName("needs_attention_count") val needsAttentionCount: Int? = null
)
